import React from "react"
import { MdClose } from "react-icons/md"

import { thousandSeparator } from "utils"
import classes from "./KcOrderCombo.module.scss"

const KcOrderCombo = props => {
  const { orderCombo } = props

  return (
    <div className={classes["card"]}>
      <div className={classes["title"]}>
        {orderCombo.name}
      </div>

      <div className={classes["card-content"]}>
        <div className={classes["row"]}>
          <div className={classes["details"]}>
            {orderCombo.items.map((comboItem, ciIndex) =>
              <div
                key={ciIndex}
                className={classes["comboItem"]}
              >
                <div className={classes["name-container"]}>
                  <span className={classes["name"]}>
                    {comboItem.foodName}
                  </span>
                  <span className={classes["quantity"]}>
                    <MdClose size={18} />
                    <b>{comboItem.quantity}</b>
                  </span>
                </div>

                {
                  !comboItem.isSimple &&
                  <div className={classes["comboItemOptionName"]}>
                    ({comboItem.optionName})
                  </div>
                }
              </div>
            )}
          </div>
        </div>

        <div className={classes["right"]}>
          <div className={classes["price"]}>
            {thousandSeparator(orderCombo.comboSetSalePrice)}
          </div>
        </div>
      </div>
    </div>
  )
}

export default KcOrderCombo